<template>
    <b-row>
        <b-col cols="12" class="pt-3">
            <ContentOrLoading>
                <b-table
                    v-if="mails.data"
                    striped
                    hover
                    :items="mails.data"
                    :fields="[
                        { key: 'id', label: 'ID' },
                        { key: 'comunicado', label: 'Asunto' },
                        { key: 'status', label: 'Estado' },
                        { key: 'created_at', label: 'Creado en' }
                    ]"
                    :busy="loading"
                    show-empty
                >
                    <template #empty>
                        <h4 class="text-center">No hay ningún resultado</h4>
                    </template>
                    <template #cell(status)="data">
                        <h5>
                            <b-badge
                                class="p-2"
                                :variant="getStatusColor(data.item.status)"
                            >
                                {{ getStatusTitle(data.item.status) }}
                            </b-badge>
                        </h5>
                    </template>
                    <template #cell(comunicado)="data">
                        <b-link :to="{ name: 'back.emails.boletines.show', params: { id: data.item.comunicado_id } }">
                            {{ data.item.comunicado }}
                        </b-link>
                    </template>
                </b-table>
                <b-pagination
                    v-if="mails.meta"
                    v-model="mails.meta.current_page"
                    :total-rows="mails.meta.total"
                    :per-page="mails.meta.per_page"
                    @page-click="pageClicked"
                />
            </ContentOrLoading>
        </b-col>
    </b-row>
</template>

<script>
    import apiService from '@/services/api-comunicados';

    export default {
        name: 'SubscriptorEmailsEnviados',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                mails: {}
            };
        },
        methods: {
            getEmails(page = 1) {
                try {
                    this.loading = true;
                    apiService.getSubscriptorMailSend(this.subscriptor.id, { page: page }).then(response => {
                        this.mails = response;
                    }).catch(error => {
                        console.error("Error fetching subscriptor:", error);
                    }).finally(() => {
                        this.loading = false;
                    });
                } catch (error) {
                    console.error("Error in getSubscriptor method:", error);
                }
            },
            getStatusTitle(status) {
                switch (status) {
                    case 'delivered':
                        return 'Enviado';
                    case 'bounced':
                        return 'Rebotado';
                    case 'failed':
                        return 'Fallido';
                    default:
                        return 'Desconocido';
                }
            },
            getStatusColor(status) {
                switch (status) {
                    case 'delivered':
                        return 'success';
                    case 'bounced':
                        return 'warning';
                    case 'failed':
                        return 'danger';
                    default:
                        return 'Desconocido';
                }
            },
            pageClicked(event, page) {
                this.getEmails(page);
            }
        },
        mounted() {
            this.getEmails();
        }
    }
</script>